import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLine33B = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 44 44",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M30 20C35.5228 20 40 15.5228 40 10C40 4.47715 35.5228 0 30 0C24.4772 0 20 4.47715 20 10C20 15.5228 24.4772 20 30 20Z",
			fill: "#82C8E6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M33.7405 11.545C33.7405 10.7761 33.3949 9.90566 32.5601 9.90566C32.1549 9.90566 31.9105 10.1202 31.6957 10.4302V8.76718H30.8553V13.1785H31.666V13.0115C31.8268 13.1607 32.107 13.2559 32.3457 13.2559C33.3651 13.2561 33.7405 12.2604 33.7405 11.545ZM32.8642 11.6644C32.8642 12.0994 32.7451 12.6598 32.2086 12.6598C31.8268 12.6598 31.696 12.463 31.696 12.2426V11.1994C31.696 11.0144 31.7138 10.925 31.8568 10.7878C31.9462 10.6985 32.0775 10.627 32.2442 10.627C32.7749 10.6272 32.8642 11.2352 32.8642 11.6644Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35.3784 9.1487C35.3784 8.89239 35.1995 8.70761 34.9134 8.70761C34.6273 8.70761 34.4425 8.89261 34.4425 9.1487C34.4425 9.40522 34.6273 9.58979 34.9134 9.58979C35.1995 9.58979 35.3784 9.40522 35.3784 9.1487ZM35.3306 13.1785V9.99544H34.4904V13.1787H35.3306V13.1785Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M29.5651 12.1051C29.5651 10.7233 28.7335 9.91354 27.6336 9.70421C28.6909 9.28538 29.241 8.50377 29.241 7.4847C29.241 6.17251 28.0849 5 26.0545 5C24.8843 5 23.9256 5.32087 23.0658 5.87938L23.7565 7.33086C24.0808 7.0519 24.687 6.61909 25.6034 6.61909C26.6469 6.61909 27.1261 7.16345 27.1261 7.7916C27.1261 8.54547 26.5199 9.01999 25.547 9.01999H24.5036V10.653H25.5327C26.5479 10.653 27.4222 11.016 27.4222 12.1466C27.4222 12.9841 26.7031 13.5983 25.547 13.5983C24.7011 13.5983 24.0102 13.2772 23.5874 12.956L22.8259 14.4777C23.6297 14.9243 24.405 15.2174 25.6879 15.2174C28 15.218 29.5651 13.8359 29.5651 12.1051Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.3258 12.2246C38.3258 11.7417 38.0456 11.4794 37.6164 11.3185L37.229 11.1754C37.0262 11.1039 36.8953 11.0263 36.8953 10.8596C36.8953 10.6687 37.0562 10.5557 37.3362 10.5557C37.539 10.5557 37.7953 10.6272 37.9801 10.7465L38.2364 10.1324C38.0695 10.0489 37.7777 9.92392 37.3782 9.92392C36.6329 9.92392 36.1262 10.3948 36.1262 10.997C36.1262 11.3726 36.3112 11.6646 36.7643 11.8374L37.1397 11.9804C37.3069 12.0461 37.5451 12.1117 37.5451 12.3322C37.5451 12.5824 37.2769 12.6539 37.0564 12.6539C36.806 12.6539 36.5138 12.5587 36.3112 12.4154L36.0547 13.0413C36.2334 13.1485 36.5914 13.2857 36.9906 13.2857C37.8251 13.2857 38.3258 12.8446 38.3258 12.2246Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31 28C31 36.2843 24.2843 43 16 43C7.71573 43 1 36.2843 1 28C1 19.7157 7.71573 13 16 13C24.2843 13 31 19.7157 31 28Z",
			fill: "#6E6E00",
			stroke: "white",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M21.8749 31.6939C21.8749 29.2163 20.3987 27.7645 18.4464 27.3892V27.3391C20.3232 26.6383 21.2996 25.2369 21.2996 23.4097C21.2996 21.057 19.2474 18.9548 15.6432 18.9548C13.566 18.9548 11.8641 19.5301 10.3378 20.5315L11.5639 23.1339C12.1396 22.6337 13.2158 21.8577 14.8425 21.8577C16.6947 21.8577 17.5455 22.8337 17.5455 23.96C17.5455 25.3116 16.4693 26.1624 14.7424 26.1624H12.8902V29.0904H14.717C16.5191 29.0904 18.0711 29.7412 18.0711 31.7683C18.0711 33.2699 16.7945 34.3711 14.7424 34.3711C13.2408 34.3711 12.0144 33.7955 11.2638 33.2195L9.91211 35.9478C11.3389 36.7485 12.7152 37.2741 14.9925 37.2741C19.0968 37.2751 21.8749 34.7972 21.8749 31.6939Z",
			fill: "white"
		})
	]
});
const ForwardRef = forwardRef(SvgLine33B);
export { ForwardRef as ReactComponent };
